export default {
  delete(id) {
    return axios.delete(import.meta.env.VITE_SITE_URL + '/crms/balance/' + id);
  },

  getBalanceByCrmOriginal(original, params = {}) {
    return axios
      .get(
        `${ import.meta.env.VITE_SITE_URL }/crms/balance/byCrmOriginal/${ original }`,
        params,
      );
  },
  sendPaymentReminderMail(id) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/${ id }/payment-reminder/send/`);
  },
  sendAllPaymentReminderMail() {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/payment-reminder/send-all/`);
  },
};
